import { useCallback, useState } from "react";
import { dateToLocale, formatMilesDecimalNew, initialText } from "@/services/Utils";
import axios from "axios";
import { useToasts } from "react-toast-notifications";

const usePrintInventoryLabel = () => {
	const [isLoading, setIsLoading] = useState(false);

	const { addToast } = useToasts();

	const getZpl = ({ productName, content, unit_measurement, id, code, expirationDate = null, businessName = null, lot = null }) => {
		content = formatMilesDecimalNew(String(content).replace(".", ","));

		const { businessPosition, productNamePosition, expirationDatePosition, contentPosition, lotPosition } = getPositions({
			productName,
			expirationDate,
			businessName: `${businessName ? `(${businessName}) ${code}` : code}`,
			lot,
		});

		const zpl = `^XA
					^PON
					^CF0,28
					^PW480
					^LL256
					${businessPosition ? `^FO200,${businessPosition}^FD${businessName ? `(${initialText(businessName)}) ` : ""}${code}^FS` : ""}
					^FO200,${productNamePosition}^FB300,3,,^FD${productName}^FS
					${expirationDatePosition ? `^FO200,${expirationDatePosition}^FD${dateToLocale(expirationDate)}^FS` : ""}
					^FO200,${contentPosition}^FD${content} ${unit_measurement}^FS
					${lotPosition ? `^FO200,${lotPosition}^FD${lot}^FS` : ""}
					^FO40,40^BQN,2,7^FDQA,${id}^FS
					^XZ`;

		return zpl;
	};

	const printInventoryLabel = useCallback(
		async (zpls) => {
			if (zpls.length > 0) {
				setIsLoading(true);
				try {
					await axios.post("http://localhost:8880", { zpls });
				} catch {
					addToast("Verifique que AgroLabelPrinter esté ejecutándose", {
						appearance: "error",
					});
				}
				setIsLoading(false);
			}
		},
		[addToast],
	);

	return { getZpl, printInventoryLabel, isLoading };
};

export default usePrintInventoryLabel;

const getPositions = ({ productName, expirationDate = null, businessName = null, lot = null }) => {
	const initialPosition = 60;
	// const finalPosition = 210;
	const maxCharsPerLine = 23;
	const productRequiresExtraLine = productName.length > maxCharsPerLine;

	let currentPosition = initialPosition;

	const lineJump = 35;

	let businessPosition = null;
	let productNamePosition;
	let expirationDatePosition = null;
	let contentPosition;
	let lotPosition = null;

	// Verify Business
	if (businessName) {
		businessPosition = initialPosition;
		currentPosition += lineJump;
		productNamePosition = currentPosition;
	} else {
		productNamePosition = initialPosition;
	}

	currentPosition += lineJump;

	if (productRequiresExtraLine) {
		currentPosition += lineJump;
	}

	if (expirationDate) {
		expirationDatePosition = currentPosition;
		currentPosition += lineJump;
	}

	contentPosition = currentPosition;
	currentPosition += lineJump;

	if (lot) {
		lotPosition = currentPosition;
	}

	return {
		businessPosition,
		productNamePosition,
		expirationDatePosition,
		contentPosition,
		lotPosition,
	};
};
